module.exports = __webpack_public_path__ + "static/media/comm-members.22155590.svg";